module.exports = __webpack_public_path__ + "img/chart_power.8ac329ef.svg";